import { gql } from '@apollo/client'

export const CREATE_DEALER = gql`
  mutation createDealer($input: CreateDealerInput!) {
    data: createDealer(input: $input) {
      id
    }
  }
`
